class FooterV1 extends HTMLElement {
    connectedCallback() {

        const menuHeaders = this.querySelectorAll('.footer-menu .heading-r');  // 菜单标题选择器

        menuHeaders.forEach(header => {
            header.addEventListener('click', function () {
                const allMenus = document.querySelectorAll('.footer-menu');  // 获取所有菜单项
                const currentMenu = this.parentElement;  // 当前点击的菜单项

                // 将所有菜单项折叠
                allMenus.forEach(menu => {
                    if (menu !== currentMenu) {
                        menu.classList.remove('active');  // 移除所有菜单项的 active 类
                    }
                });

                // 切换当前点击菜单的展开状态
                currentMenu.classList.toggle('active');
            });
        });

        const checkbox = this.querySelector('[name="accepts_marketing"]');
        const errorMsg = this.querySelector('.error-message');
        const form = this.querySelector('form');

        if (checkbox && errorMsg && form) {
            form.addEventListener('submit', function (e) {
                // 修复：添加空值检查和类型断言
                if (!checkbox || !(checkbox instanceof HTMLInputElement) || !checkbox.checked) {
                    e.preventDefault();
                    if (errorMsg && (errorMsg instanceof HTMLElement)) {
                        errorMsg.style.display = 'block';
                    }
                } else {
                    if (errorMsg && (errorMsg instanceof HTMLElement)) {
                        errorMsg.style.display = 'none';
                    }
                }
            });
        }
    }
}

// 注册自定义元素
reg("footer-v1", FooterV1);
